import React, {useState} from "react";
import classNames from "classnames";
import "./index.scss";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon/index.js";

const initValue = {key: '', value: ''};

const SectionItemIconSelector = ({column, item, values, value: valueKey, onPropChange, getData, withTitle = true}) => {
    const [value, setValue] = useState(initValue);

    const valueByKey = values?.find(el => el?.key === valueKey) || column?.values?.find(el => el?.key === valueKey);

    if (value.key !== valueKey && valueByKey) {
        setValue(valueByKey);
    }

    const handleOnChange = val => {
        if (column.action && val) {
            getData(column.action, val.key);
        }
        if (value.key !== val.key) {
            if (column.onPropChange) {
                column.onPropChange(val, column, onPropChange);
            } else {
                const dataToRefresh = column.dataToRefresh || {};
                onPropChange({ ...dataToRefresh, [column.accessor]: val['key'] });
            }
        }
        setValue(val);
    };

    return (
        <div key={`propItem-${column.accessor}`} className={classNames("sectionItemIconSelector")}>
            {withTitle && <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange}/>}

            <div className={classNames("sectionItemIconSelectorBlock")}>
                {(values && values.length > 0) && values.map((element, indexElement) =>
                    <div key={indexElement} onClick={() => handleOnChange(element)} className={classNames("iconButton", {iconButtonSelected: element.key === value.key})}>
                    <div className={classNames(`actionIcon ${element.icon}`)}/>
                </div>)}
            </div>

        </div>
    );
}

export default SectionItemIconSelector;
